import { createContext, useContext } from "react"
import type { CustomBot } from "@/entities/bot-builder"
import type { useScenarioDraft } from "@/features/edit-scenario-draft"

export type ScenarioDraftState = ReturnType<typeof useScenarioDraft>

export interface BotWorkspace {
	bot: CustomBot
	/** Черновик сценария бота; null: бот ещё без сценария. */
	draft: ScenarioDraftState | null
}

export const BotWorkspaceContext = createContext<BotWorkspace | null>(null)

/** Страница внутри раздела бота (/admin/bots/:botId/...). */
export function useBotWorkspace(): BotWorkspace {
	const workspace = useContext(BotWorkspaceContext)
	if (!workspace) throw new Error("useBotWorkspace вне раздела бота")
	return workspace
}

/** null: страница открыта вне раздела бота. */
export function useOptionalBotWorkspace(): BotWorkspace | null {
	return useContext(BotWorkspaceContext)
}

export const botPath = (botId: string, section = "") =>
	`/admin/bots/${botId}${section ? `/${section}` : ""}`

/**
 * Внутренняя страница раздела (одна рассылка, один пользователь, одна метка): у неё своя
 * шапка, как у материала в «Контенте», со ссылкой назад к списку вместо шапки бота и вкладок.
 */
export interface InnerPage {
	back: { to: string; label: string }
	botName: string
}

export const InnerPageContext = createContext<InnerPage | null>(null)
